import dayjs from "dayjs";
import {
  ADD_NEW_PATIENT_FAIL,
  ADD_NEW_PATIENT_REQUEST,
  ADD_NEW_PATIENT_SUCCESS,
  ADD_PATIENT_DETAILS_FAIL,
  ADD_PATIENT_DETAILS_REQUEST,
  ADD_PATIENT_DETAILS_SUCCESS,
  ADD_PATIENT_PASSWORD_FAIL,
  ADD_PATIENT_PASSWORD_REQUEST,
  ADD_PATIENT_PASSWORD_SUCCESS,
  ADD_RECORD_CONSENT_FAIL,
  ADD_RECORD_CONSENT_REQUEST,
  ADD_RECORD_CONSENT_SUCCESS,
  CREATE_ENROLMENT_FAIL,
  CREATE_ENROLMENT_REQUEST,
  CREATE_ENROLMENT_SUCCESS,
  DELETE_PATIENT_FAIL,
  DELETE_PATIENT_NOTE_FAIL,
  DELETE_PATIENT_NOTE_REQUEST,
  DELETE_PATIENT_NOTE_SUCCESS,
  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  EDUCATION_SETUP_FAIL,
  EDUCATION_SETUP_REQUEST,
  EDUCATION_SETUP_SUCCESS,
  EQUIP_SETUP_FAIL,
  EQUIP_SETUP_REQUEST,
  EQUIP_SETUP_SUCCESS,
  GENERATE_EVIDENCE_FAIL,
  GENERATE_EVIDENCE_REQUEST,
  GENERATE_EVIDENCE_SUCCESS,
  GET_AGENCY_PATIENTS_FAIL,
  GET_AGENCY_PATIENTS_REQUEST,
  GET_AGENCY_PATIENTS_SUCCESS,
  GET_ALL_PATIENTS_FAIL,
  GET_ALL_PATIENTS_REQUEST,
  GET_ALL_PATIENTS_SUCCESS,
  GET_A_PATIENT_BY_PID_FAIL,
  GET_A_PATIENT_BY_PID_REQUEST,
  GET_A_PATIENT_BY_PID_SUCCESS,
  GET_PATIENT_AGENT_ROLES_FAIL,
  GET_PATIENT_AGENT_ROLES_REQUEST,
  GET_PATIENT_AGENT_ROLES_SUCCESS,
  RESET_PATIENT_AGENT_ROLES,
  GET_CHART_PAINLOGS_FAIL,
  GET_CHART_PAINLOGS_REQUEST,
  GET_CHART_PAINLOGS_SUCCESS,
  GET_CLIENT_PAINLOGS_FAIL,
  GET_CLIENT_PAINLOGS_REQUEST,
  GET_CLIENT_PAINLOGS_SUCCESS,
  GET_DASHBOARD_ALERTS_FAIL,
  GET_DASHBOARD_ALERTS_REQUEST,
  GET_DASHBOARD_ALERTS_SUCCESS,
  GET_DASHBOARD_ANALYTICS_FAIL,
  GET_DASHBOARD_ANALYTICS_REQUEST,
  GET_DASHBOARD_ANALYTICS_SUCCESS,
  GET_ENROLMENTS_LIST_FAIL,
  GET_ENROLMENTS_LIST_REQUEST,
  GET_ENROLMENTS_LIST_SUCCESS,
  GET_ENROLMENT_TIMELINE_FAIL,
  GET_ENROLMENT_TIMELINE_REQUEST,
  GET_ENROLMENT_TIMELINE_SUCCESS,
  GET_LAST_LAB_DATE_FAIL,
  GET_LAST_LAB_DATE_REQUEST,
  GET_LAST_LAB_DATE_SUCCESS,
  GET_BMI_RESPONSES_FAIL,
  GET_BMI_RESPONSES_REQUEST,
  GET_BMI_RESPONSES_SUCCESS,
  GET_MEDICINE_DATA_FAIL,
  GET_MEDICINE_DATA_REQUEST,
  GET_MEDICINE_DATA_SUCCESS,
  GET_ONCOLOGY_RESPONSES_FAIL,
  GET_ONCOLOGY_RESPONSES_REQUEST,
  GET_ONCOLOGY_RESPONSES_SUCCESS,
  GET_PHQ_RESPONSES_FAIL,
  GET_PHQ_RESPONSES_REQUEST,
  GET_PHQ_RESPONSES_SUCCESS,
  GET_QOL_ANSWERS_FAIL,
  GET_QOL_ANSWERS_REQUEST,
  GET_QOL_ANSWERS_SUCCESS,
  GET_MINIMISED_NOTE_FAIL,
  GET_MINIMISED_NOTE_REQUEST,
  GET_MINIMISED_NOTE_SUCCESS,
  GET_NEXT_PATIENT_FAIL,
  GET_NEXT_PATIENT_REQUEST,
  GET_NEXT_PATIENT_SUCCESS,
  GET_PAIN_STATS_FAIL,
  GET_PAIN_STATS_REQUEST,
  GET_PAIN_STATS_SUCCESS,
  GET_PATIENT_OVERVIEW_SUMMARY_FAIL,
  GET_PATIENT_OVERVIEW_SUMMARY_REQUEST,
  GET_PATIENT_OVERVIEW_SUMMARY_SUCCESS,
  GET_PATIENT_REPORTS_FAIL,
  GET_PATIENT_REPORTS_REQUEST,
  GET_PATIENT_REPORTS_SUCCESS,
  GET_PIE_CHART_STATS_FAIL,
  GET_PIE_CHART_STATS_REQUEST,
  GET_PIE_CHART_STATS_SUCCESS,
  GET_PINNED_NOTES_FAIL,
  GET_PINNED_NOTES_REQUEST,
  GET_PINNED_NOTES_SUCCESS,
  GET_TABS_COUNT_FAIL,
  GET_TABS_COUNT_REQUEST,
  GET_TABS_COUNT_SUCCESS,
  GET_UNPAGINATED_PATIENTS_FAIL,
  GET_UNPAGINATED_PATIENTS_REQUEST,
  GET_UNPAGINATED_PATIENTS_SUCCESS,
  GET_UNREAD_CHAT_MESSAGES_FAIL,
  GET_UNREAD_CHAT_MESSAGES_REQUEST,
  GET_UNREAD_CHAT_MESSAGES_SUCCESS,
  LOG_ENROLMENT_VISIT_FAIL,
  LOG_ENROLMENT_VISIT_REQUEST,
  LOG_ENROLMENT_VISIT_SUCCESS,
  PCM_ENROLMENT_CONSENT_FAIL,
  PCM_ENROLMENT_CONSENT_REQUEST,
  PCM_ENROLMENT_CONSENT_SUCCESS,
  REENROLL_PATIENT_FAIL,
  REENROLL_PATIENT_REQUEST,
  REENROLL_PATIENT_SUCCESS,
  RESET_ADD_PATIENT_DETAILS,
  RESET_ADD_PATIENT_PASSWORD,
  RESET_ALL_PATIENTS,
  RESET_A_PATIENT_BY_PID,
  RESET_CREATE_ENROLMENT,
  RESET_DELETE_PATIENT,
  RESET_EDUCATION_SETUP,
  RESET_EQUIP_SETUP,
  RESET_GET_AGENCY_PATIENTS,
  RESET_GET_TABS_COUNT,
  RESET_LISTING_STATES,
  RESET_LOG_ENROLMENT_VISIT,
  RESET_MEDICINE_DATA,
  RESET_MINIMISED_NOTE,
  RESET_NEXT_PATIENT,
  RESET_PCM_ENROLMENT_CONSENT,
  RESET_PIE_CHART_STATS,
  RESET_RECORD_CONSENT,
  RESET_REENROLL_PATIENT,
  RESET_UNENROLL_PATIENT,
  RESET_UNPAGINATED_PATIENTS,
  RESET_UN_ENROLMENT_PROGRAM,
  RESET_UPDATE_CONTACT_NUMBER,
  RESET_UPDATE_MOBILE_PASSWORD,
  SET_ADDED_ON_VALUE,
  SET_ADDED_VIA,
  SET_ASSIGNED_TO,
  SET_CARE_PLAN,
  SET_CONSENT_STATUS,
  SET_CPT_CODES_ITEMS,
  SET_EDUCATION_GIVEN,
  SET_ENROLLMENT_STATUS,
  SET_FROM_CUSTOM_DATE_VALUE,
  SET_INITIATING_VISIT,
  SET_LISTING_TAB,
  SET_MOBILE_APP_ACTIVITY_VALUE,
  SET_NEXT_PATIENT_OBJECT,
  SET_PAGE_NUMBER,
  SET_PAGE_SIZE,
  SET_PROGRAM_VALUE,
  SET_QUERY,
  SET_SENT_CREDENTIALS,
  SET_SORTED_ITEMS,
  SET_TO_CUSTOM_DATE_VALUE,
  SET_UNENROLLED_BY_VALUE,
  SET_UNENROLLMENT_REASON_VALUE,
  UNENROLL_PATIENT_FAIL,
  UNENROLL_PATIENT_REQUEST,
  UNENROLL_PATIENT_SUCCESS,
  UN_ENROLMENT_PROGRAM_FAIL,
  UN_ENROLMENT_PROGRAM_REQUEST,
  UN_ENROLMENT_PROGRAM_SUCCESS,
  UPDATE_CONTACT_NUMBER_FAIL,
  UPDATE_CONTACT_NUMBER_REQUEST,
  UPDATE_CONTACT_NUMBER_SUCCESS,
  UPDATE_MOBILE_PASSWORD_FAIL,
  UPDATE_MOBILE_PASSWORD_REQUEST,
  UPDATE_MOBILE_PASSWORD_SUCCESS,
  UPDATE_PATIENT_FAIL,
  UPDATE_PATIENT_REQUEST,
  UPDATE_PATIENT_RESET,
  UPDATE_PATIENT_SUCCESS,
} from "../../assets/constants/patientConstants";

const initTabState = {
  tab: "all",
  page: 0,
  pageSize: 10,
  assignedTo: [],
  sentCredentialsValue: "",
  enrollmentStatus: "all",
  educationGiven: "",
  consentStatusValue: "",
  query: "",
  cptCodeItems: [],
  sortedItems: "",
  nextPatientObject: {},
  programValue: "all",
  mobileAppActivityValue: "all",
  addedOnValue: "all",
  unenrollmentReasonValue: "all",
  unenrolledByValue: "all",
  addedViaValue: "all",
  initiatingVisitValue: "all",
  carePlanValue: "all",
  fromCustomDateValue: null,
  toCustomDateValue: null,
};

export const patientListingStateReducer = (state = initTabState, action) => {
  switch (action.type) {
    case SET_PAGE_NUMBER:
      return {
        ...state,
        page: action.payload,
      };
    case SET_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload,
      };
    case SET_LISTING_TAB:
      return {
        ...state,
        tab: action.payload,
      };

    case SET_ASSIGNED_TO:
      return {
        ...state,
        assignedTo: action.payload,
      };

    case SET_SENT_CREDENTIALS:
      return {
        ...state,
        sentCredentialsValue: action.payload,
      };

    case SET_ENROLLMENT_STATUS:
      return {
        ...state,
        enrollmentStatus: action.payload,
      };

    case SET_PROGRAM_VALUE:
      return {
        ...state,
        programValue: action.payload,
      };

    case SET_MOBILE_APP_ACTIVITY_VALUE:
      return {
        ...state,
        mobileAppActivityValue: action.payload,
      };

    case SET_ADDED_ON_VALUE:
      return {
        ...state,
        addedOnValue: action.payload,
      };

    case SET_UNENROLLMENT_REASON_VALUE:
      return {
        ...state,
        unenrollmentReasonValue: action.payload,
      };

    case SET_UNENROLLED_BY_VALUE:
      return {
        ...state,
        unenrolledByValue: action.payload,
      };

    case SET_EDUCATION_GIVEN:
      return {
        ...state,
        educationGiven: action.payload,
      };

    case SET_INITIATING_VISIT:
      return {
        ...state,
        initiatingVisitValue: action.payload,
      };

    case SET_CARE_PLAN:
      return {
        ...state,
        carePlanValue: action.payload,
      };

    case SET_ADDED_VIA:
      return {
        ...state,
        addedViaValue: action.payload,
      };

    case SET_CONSENT_STATUS:
      return {
        ...state,
        consentStatusValue: action.payload,
      };

    case SET_QUERY:
      return {
        ...state,
        query: action.payload,
      };

    case SET_CPT_CODES_ITEMS:
      return {
        ...state,
        cptCodeItems: action.payload,
      };

    case SET_SORTED_ITEMS:
      return {
        ...state,
        sortedItems: action.payload,
      };

    case SET_NEXT_PATIENT_OBJECT:
      return {
        ...state,
        nextPatientObject: action.payload,
      };

    case SET_FROM_CUSTOM_DATE_VALUE:
      return {
        ...state,
        fromCustomDateValue: action.payload,
      };

    case SET_TO_CUSTOM_DATE_VALUE:
      return {
        ...state,
        toCustomDateValue: action.payload,
      };

    case RESET_LISTING_STATES:
      return {
        tab: "all",
        page: 0,
        pageSize: 10,
        assignedTo: [],
        enrollmentStatus: "all",
        educationGiven: "",
        sentCredentialsValue: "",
        consentStatusValue: "",
        query: "",
        cptCodeItems: [],
        sortedItems: "",
        nextPatientObject: {},
        programValue: "all",
        mobileAppActivityValue: "all",
        addedOnValue: "all",
        unenrollmentReasonValue: "all",
        unenrolledByValue: "all",
        addedViaValue: "all",
        initiatingVisitValue: "all",
        carePlanValue: "all",
        fromCustomDateValue: null,
        toCustomDateValue: null,
      };

    default:
      return { ...state };
  }
};

// GET ALL CASES REDUCER
export const getAllCasesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_PATIENTS_REQUEST:
      return { loading: true };
    case GET_ALL_PATIENTS_SUCCESS:
      return { loading: false, cases: action.payload };
    case GET_ALL_PATIENTS_FAIL:
      return { loading: false, error: action.payload };
    case RESET_ALL_PATIENTS:
      return { loading: false, cases: [] };
    default:
      return state;
  }
};

// GET TABS COUNT REDUCER
export const getTabsCountReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TABS_COUNT_REQUEST:
      return { loading: true };
    case GET_TABS_COUNT_SUCCESS:
      return { loading: false, tabsCount: action.payload };
    case GET_TABS_COUNT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_GET_TABS_COUNT:
      return {};
    default:
      return state;
  }
};

// GET NEXT PATIENT REDUCER
export const getNextPatientReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_NEXT_PATIENT_REQUEST:
      return { loading: true };
    case GET_NEXT_PATIENT_SUCCESS:
      return { loading: false, nextPatientData: action.payload };
    case GET_NEXT_PATIENT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_NEXT_PATIENT:
      return {};
    default:
      return state;
  }
};

//  GET_PATIENT_OVERVIEW_SUMMARY_REQUEST REDUCER
export const getPatientOverviewSummaryReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PATIENT_OVERVIEW_SUMMARY_REQUEST:
      return { loading: true };
    case GET_PATIENT_OVERVIEW_SUMMARY_SUCCESS:
      return { loading: false, patientOverviewSummary: action.payload };
    case GET_PATIENT_OVERVIEW_SUMMARY_FAIL:
      return { loading: false, error: action.payload };
    // case RESET_PATIENT_OVERVIEW_SUMMARY:
    //   return {};
    default:
      return state;
  }
};

// GET ALL PATIENTS BY AGENCY REDUCER
export const getAllPatientsByAgencyReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_AGENCY_PATIENTS_REQUEST:
      return { loading: true, allAgencyPatients: [], error: null };
    case GET_AGENCY_PATIENTS_SUCCESS:
      return { loading: false, allAgencyPatients: action.payload, error: null };
    case GET_AGENCY_PATIENTS_FAIL:
      return { loading: false, error: action.payload, allAgencyPatients: [] };
    case RESET_GET_AGENCY_PATIENTS:
      return {};
    default:
      return state;
  }
};

// GET ALL UNPAGINATED CASES REDUCER
export const getUnpaginatedPatientsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_UNPAGINATED_PATIENTS_REQUEST:
      return { loading: true, allUnpaginatedCases: [] };
    case GET_UNPAGINATED_PATIENTS_SUCCESS:
      return { loading: false, allUnpaginatedCases: action.payload };
    case GET_UNPAGINATED_PATIENTS_FAIL:
      return { loading: false, error: action.payload };
    case RESET_UNPAGINATED_PATIENTS:
      return { loading: false, allUnpaginatedCases: [] };
    default:
      return state;
  }
};

// GET A CASE BY CID REDUCER
export const getPatientByPatientIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_A_PATIENT_BY_PID_REQUEST:
      return { loading: true };
    case GET_A_PATIENT_BY_PID_SUCCESS:
      return { loading: false, patientDetail: action.payload };
    case GET_A_PATIENT_BY_PID_FAIL:
      return { loading: false, error: action.payload };
    case RESET_A_PATIENT_BY_PID:
      return {};
    default:
      return state;
  }
};

// Roles each assigned agent holds for a specific patient
export const getPatientAgentRolesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PATIENT_AGENT_ROLES_REQUEST:
      return { ...state, loading: true };
    case GET_PATIENT_AGENT_ROLES_SUCCESS:
      return {
        loading: false,
        patientId: action.payload?.patient_id,
        assignments: action.payload?.assignments || [],
      };
    case GET_PATIENT_AGENT_ROLES_FAIL:
      return { loading: false, error: action.payload };
    case RESET_PATIENT_AGENT_ROLES:
      return {};
    default:
      return state;
  }
};

// CREATE ENROLMENT REDUCER
export const createEnrolmentReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_ENROLMENT_REQUEST:
      return { loading: true };
    case CREATE_ENROLMENT_SUCCESS:
      return { loading: false, createdEnrolment: action.payload };
    case CREATE_ENROLMENT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_ENROLMENT:
      return {};
    default:
      return state;
  }
};

// UN ENROLMENT PROGRAM REDUCER
export const unEnrolmentProgramReducer = (state = {}, action) => {
  switch (action.type) {
    case UN_ENROLMENT_PROGRAM_REQUEST:
      return { loading: true };
    case UN_ENROLMENT_PROGRAM_SUCCESS:
      return { loading: false, unenrolledProgram: action.payload };
    case UN_ENROLMENT_PROGRAM_FAIL:
      return { loading: false, error: action.payload };
    case RESET_UN_ENROLMENT_PROGRAM:
      return {};
    default:
      return state;
  }
};

// GET ENROLMENTS LIST REDUCER
export const getEnrolmentsListReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ENROLMENTS_LIST_REQUEST:
      return { ...state, loading: true, error: undefined };
    case GET_ENROLMENTS_LIST_SUCCESS:
      return { loading: false, enrolmentsList: action.payload };
    case GET_ENROLMENTS_LIST_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

// LOG ENROLMENT VISIT FOR PCM REDUCER
export const logEnrolmentVisitReducer = (state = {}, action) => {
  switch (action.type) {
    case LOG_ENROLMENT_VISIT_REQUEST:
      return { loading: true };
    case LOG_ENROLMENT_VISIT_SUCCESS:
      return { loading: false, visitLogged: action.payload };
    case LOG_ENROLMENT_VISIT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_LOG_ENROLMENT_VISIT:
      return {};
    default:
      return state;
  }
};

// PCM ENROLMENT CONSENT REDUCER
export const pcmEnrolmentConsentReducer = (state = {}, action) => {
  switch (action.type) {
    case PCM_ENROLMENT_CONSENT_REQUEST:
      return { loading: true };
    case PCM_ENROLMENT_CONSENT_SUCCESS:
      return { loading: false, pcmConsent: action.payload };
    case PCM_ENROLMENT_CONSENT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_PCM_ENROLMENT_CONSENT:
      return {};
    default:
      return state;
  }
};

// ADD RECORD CONSENT REDUCER
export const addRecordConsentReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_RECORD_CONSENT_REQUEST:
      return { loading: true };
    case ADD_RECORD_CONSENT_SUCCESS:
      return { loading: false, consentRecorded: action.payload };
    case ADD_RECORD_CONSENT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_RECORD_CONSENT:
      return {};
    default:
      return state;
  }
};

// ADD EQUIP SETUP REDUCER
export const addEquipSetupReducer = (state = {}, action) => {
  switch (action.type) {
    case EQUIP_SETUP_REQUEST:
      return { loading: true };
    case EQUIP_SETUP_SUCCESS:
      return { loading: false, equipSetupDone: action.payload };
    case EQUIP_SETUP_FAIL:
      return { loading: false, error: action.payload };
    case RESET_EQUIP_SETUP:
      return {};
    default:
      return state;
  }
};

// ADD EDUCATION SETUP REDUCER
export const addEducationSetupReducer = (state = {}, action) => {
  switch (action.type) {
    case EDUCATION_SETUP_REQUEST:
      return { loading: true };
    case EDUCATION_SETUP_SUCCESS:
      return { loading: false, educationSetupDone: action.payload };
    case EDUCATION_SETUP_FAIL:
      return { loading: false, error: action.payload };
    case RESET_EDUCATION_SETUP:
      return {};
    default:
      return state;
  }
};

// UNENROLL PATIENT REDUCER
export const unEnrollPatientReducer = (state = {}, action) => {
  switch (action.type) {
    case UNENROLL_PATIENT_REQUEST:
      return { loading: true };
    case UNENROLL_PATIENT_SUCCESS:
      return { loading: false, unEnrolledPatient: action.payload };
    case UNENROLL_PATIENT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_UNENROLL_PATIENT:
      return {};
    default:
      return state;
  }
};

// GET ALL CASES REDUCER
export const updateCaseReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PATIENT_REQUEST:
      return { loading: true };
    case UPDATE_PATIENT_SUCCESS:
      return { loading: false, updatedCase: action.payload };
    case UPDATE_PATIENT_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_PATIENT_RESET:
      return {};
    default:
      return state;
  }
};

// GET CLIENT PAINLOGS REDUCER
export const getClientPainlogsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CLIENT_PAINLOGS_REQUEST:
      return { loading: true };
    case GET_CLIENT_PAINLOGS_SUCCESS:
      return { loading: false, painlogs: action.payload };
    case GET_CLIENT_PAINLOGS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET LAST LAB REDUCER
export const getLastLabDateReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LAST_LAB_DATE_REQUEST:
      return { loading: true };
    case GET_LAST_LAB_DATE_SUCCESS:
      return { loading: false, lastLabDate: action.payload };
    case GET_LAST_LAB_DATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET PAIN STATS REDUCER
export const getPainStatsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PAIN_STATS_REQUEST:
      return { loading: true };
    case GET_PAIN_STATS_SUCCESS:
      return { loading: false, painStats: action.payload };
    case GET_PAIN_STATS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET MEDICINE DATA REDUCER
export const getMedicineDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MEDICINE_DATA_REQUEST:
      return { loading: true };
    case GET_MEDICINE_DATA_SUCCESS:
      return { loading: false, medicineData: action.payload };
    case GET_MEDICINE_DATA_FAIL:
      return { loading: false, error: action.payload };
    case RESET_MEDICINE_DATA:
      return {};
    default:
      return state;
  }
};

// GET CHART PAINLOGS REDUCER
export const getChartPainlogsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CHART_PAINLOGS_REQUEST:
      return { loading: true };
    case GET_CHART_PAINLOGS_SUCCESS:
      return { loading: false, chartPainLogs: action.payload };
    case GET_CHART_PAINLOGS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// ADD/POST NEW CASE REDUCER
export const addNewCaseReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_NEW_PATIENT_REQUEST:
      return { loading: true };
    case ADD_NEW_PATIENT_SUCCESS:
      return { loading: false, newcase: action.payload };
    case ADD_NEW_PATIENT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// DELETE CASE LISTING REDUCER
export const deleteCaseReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_PATIENT_REQUEST:
      return { loading: true };
    case DELETE_PATIENT_SUCCESS:
      return { loading: false, success: true };
    case DELETE_PATIENT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_DELETE_PATIENT:
      return { loading: false, success: false };
    default:
      return state;
  }
};

// GENERATE EVIDENCE PDF REDUCER
export const generateEvidenceReducer = (state = {}, action) => {
  switch (action.type) {
    case GENERATE_EVIDENCE_REQUEST:
      return { loading: true, error: null };
    case GENERATE_EVIDENCE_SUCCESS:
      return {
        loading: false,
        generatedReport: action.payload,
      };
    case GENERATE_EVIDENCE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET DASHBOARD ANALYTICS REDUCER
export const getDashboardAnalyticsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_DASHBOARD_ANALYTICS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_DASHBOARD_ANALYTICS_SUCCESS:
      return { ...state, loading: false, dashboardAnalytic: action.payload };
    case GET_DASHBOARD_ANALYTICS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET DASHBOARD ALERTS REDUCER
export const getDashboardAlertsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_DASHBOARD_ALERTS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_DASHBOARD_ALERTS_SUCCESS:
      return { ...state, loading: false, dashboardAlert: action.payload };
    case GET_DASHBOARD_ALERTS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET UNREAD CHAT MESSAGES REDUCER
export const getUnreadChatMessagesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_UNREAD_CHAT_MESSAGES_REQUEST:
      return { loading: true, error: null };
    case GET_UNREAD_CHAT_MESSAGES_SUCCESS:
      return {
        loading: false,
        unreadChatMessages: action.payload,
        error: null,
      };
    case GET_UNREAD_CHAT_MESSAGES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET PIE CHART STATS REDUCER
export const getPieChartStatsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PIE_CHART_STATS_REQUEST:
      return { loading: true, error: null };
    case GET_PIE_CHART_STATS_SUCCESS:
      return {
        loading: false,
        pieChartStats: action.payload,
        error: null,
      };
    case GET_PIE_CHART_STATS_FAIL:
      return { loading: false, error: action.payload };
    case RESET_PIE_CHART_STATS:
      return { loading: false, error: null, pieChartStats: {} };
    default:
      return state;
  }
};

// ADD PATIENT DETAILS REDUCER
export const addPatientDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_PATIENT_DETAILS_REQUEST:
      return { loading: true };
    case ADD_PATIENT_DETAILS_SUCCESS:
      return { loading: false, patientDetails: action.payload };
    case ADD_PATIENT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case RESET_ADD_PATIENT_DETAILS:
      return {};
    default:
      return state;
  }
};

// ADD PATIENT PASSWORD REDUCER
export const addPatientPasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_PATIENT_PASSWORD_REQUEST:
      return { loading: true };
    case ADD_PATIENT_PASSWORD_SUCCESS:
      return { loading: false, patientPassword: action.payload };
    case ADD_PATIENT_PASSWORD_FAIL:
      return { loading: false, error: action.payload };
    case RESET_ADD_PATIENT_PASSWORD:
      return {};
    default:
      return state;
  }
};

// RE ENROLL PATIENT REDUCER
export const reEnrollPatientReducer = (state = {}, action) => {
  switch (action.type) {
    case REENROLL_PATIENT_REQUEST:
      return { loading: true };
    case REENROLL_PATIENT_SUCCESS:
      return { loading: false, reEnrolledPatient: action.payload };
    case REENROLL_PATIENT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_REENROLL_PATIENT:
      return {};
    default:
      return state;
  }
};

// GET PATIENT REPORTS REDUCER
export const getPatientReportsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PATIENT_REPORTS_REQUEST:
      return { loading: true };
    case GET_PATIENT_REPORTS_SUCCESS:
      return { loading: false, patientReports: action.payload };
    case GET_PATIENT_REPORTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET PINNED NOTES REDUCER
export const getPinnedNotesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PINNED_NOTES_REQUEST:
      return { loading: true };
    case GET_PINNED_NOTES_SUCCESS:
      return { loading: false, pinnedNotes: action.payload };
    case GET_PINNED_NOTES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// DELETE PATIENT NOTE REDUCER
export const deletePatientNoteReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_PATIENT_NOTE_REQUEST:
      return { loading: true };
    case DELETE_PATIENT_NOTE_SUCCESS:
      return { loading: false, deletedNote: action.payload };
    case DELETE_PATIENT_NOTE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET MINIMISED NOTE REDUCER
export const getMinimisedNoteReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MINIMISED_NOTE_REQUEST:
      return { loading: true };
    case GET_MINIMISED_NOTE_SUCCESS:
      return { loading: false, minimisedNote: action.payload };
    case GET_MINIMISED_NOTE_FAIL:
      return { loading: false, error: action.payload };
    case RESET_MINIMISED_NOTE:
      return {};
    default:
      return state;
  }
};

// UPDATE CONTACT NUMBER REDUCER
export const updateContactNumberReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_CONTACT_NUMBER_REQUEST:
      return { loading: true };
    case UPDATE_CONTACT_NUMBER_SUCCESS:
      return { loading: false, updatedPhoneNumber: action.payload };
    case UPDATE_CONTACT_NUMBER_FAIL:
      return { loading: false, error: action.payload };
    case RESET_UPDATE_CONTACT_NUMBER:
      return {};
    default:
      return state;
  }
};

// GET ENROLMENT JOURNEY TIMELINE REDUCER
export const getEnrolmentTimelineReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ENROLMENT_TIMELINE_REQUEST:
      return { loading: true };
    case GET_ENROLMENT_TIMELINE_SUCCESS:
      return { loading: false, enrolmentTimelineData: action.payload };
    case GET_ENROLMENT_TIMELINE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// UPDATE MOBILE PASSWORD REDUCER
export const updateMobilePasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_MOBILE_PASSWORD_REQUEST:
      return { loading: true };
    case UPDATE_MOBILE_PASSWORD_SUCCESS:
      return { loading: false, updatedMobilePassword: action.payload };
    case UPDATE_MOBILE_PASSWORD_FAIL:
      return { loading: false, error: action.payload };
    case RESET_UPDATE_MOBILE_PASSWORD:
      return {};
    default:
      return state;
  }
};

// GET QOL ANSWERS REDUCER
export const getQolAnswersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_QOL_ANSWERS_REQUEST:
      return { loading: true };
    case GET_QOL_ANSWERS_SUCCESS:
      return { loading: false, qolAnswers: action.payload };
    case GET_QOL_ANSWERS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET BMI RESPONSES REDUCER
export const getBmiResponsesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_BMI_RESPONSES_REQUEST:
      return { loading: true };
    case GET_BMI_RESPONSES_SUCCESS:
      return { loading: false, bmiResponses: action.payload };
    case GET_BMI_RESPONSES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET PHQ-9 RESPONSES REDUCER
export const getPhqResponsesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PHQ_RESPONSES_REQUEST:
      return { loading: true };
    case GET_PHQ_RESPONSES_SUCCESS:
      return { loading: false, phqResponses: action.payload };
    case GET_PHQ_RESPONSES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET ONCOLOGY ASSESSMENT RESPONSES REDUCER
export const getOncologyResponsesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ONCOLOGY_RESPONSES_REQUEST:
      return { loading: true };
    case GET_ONCOLOGY_RESPONSES_SUCCESS:
      return { loading: false, oncologyResponses: action.payload };
    case GET_ONCOLOGY_RESPONSES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
